(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/about.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/about.js'); 'use strict';

svs.player_login.behaviors.About = Marionette.Behavior.extend({
  ui: {
    helpLink: '.js-help'
  },
  events: {
    'click @ui.helpLink': 'onHelpClick'
  },

  onHelpClick() {
    let template = svs.player_login.templates.about();

    if (svs.core.detect.feature('ft-freja-custreg')) {
      if (this.view.model.get('isCustomerRegistration')) {
        template = svs.player_login.templates.aboutreg();
      }
    }

    svs.components.Modal.show(template, null, {
      doubleWidth: !svs.core.detect.formfactor.mobile(),
      title: 'Hjälp',
      leftButton: {
        text: 'Stäng',
        visible: true
      },
      rightButton: {
        visible: false
      }
    });
  }

});
 })(window);